import React from "react"
import { Redirect } from "react-router-dom"
import { Progress } from "@carrotfertility/carotene-core"
import { useIsSprintsVisible } from "#/services/user/hooks/useSprintsQuery"
import { DbgPaths } from "#/utils/Paths"
import SprintIntroPage from "./page"

export function SprintsLandingPageRoute(): JSX.Element {
  const { isVisible: shouldShowSprintsPage, isLoading } = useIsSprintsVisible()

  if (isLoading) {
    return <Progress />
  }

  if (!shouldShowSprintsPage) {
    return <Redirect to={DbgPaths.METABOLIC_FERTILITY_HEALTH} />
  }

  return <SprintIntroPage />
}
